<template>
  <div id="app">
    <router-view/>
  </div>
</template>
<script>

export default {
  data() {
    return {}
  },
}
</script>
<style>
html,
body {
  width: 100vw;
  height: 100vh;
  box-sizing: border-box;
}

body {
  font-size: 16px !important;
  background-color: #f8f8f8;
  -webkit-font-smoothing: antialiased;
}

#app {
  /* max-width: 650px; */
  margin: 0 auto;
  height: 100vh;
}
</style>
